import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaInfo } from '../../../types'
import { mediaInfoFromSource } from '../../../utils/media/media-info'

const useSourceInfo = (source: File | string): MediaInfo | undefined => {
    const [info, setInfo] = useState<MediaInfo | undefined>()

    useAsyncEffect(async () => {
        try {
            const info = await mediaInfoFromSource(source)
            setInfo(info || undefined)
        } catch (error) {
            setInfo(undefined)
        }
    }, [source])

    return info
}

export default useSourceInfo
